import { useState } from "react";
import { ArrowLeft, Eye, EyeOff, LockKeyhole } from "lucide-react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { Logo } from "../components/Logo";

export function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  if (user) return <Navigate to="/painel" replace />;

  async function submit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault(); setError(""); setLoading(true);
    const data = new FormData(event.currentTarget);
    try {
      await login(String(data.get("email")), String(data.get("password")));
      const destination = (location.state as { from?: string } | null)?.from ?? "/painel";
      navigate(destination, { replace: true });
    } catch (requestError) { setError((requestError as Error).message); }
    finally { setLoading(false); }
  }

  return <div className="login-page"><div className="login-art"><Logo /><div><span className="eyebrow">GESTÃO COMPLETA</span><h1>O controle da arena,<br /><em>na palma da mão.</em></h1><p>Agenda, bar, mesas, equipe e caixa trabalhando juntos.</p></div><small>ARENA SUL MINAS · BEACH SPORTS</small></div><div className="login-panel"><a href="/" className="back-link"><ArrowLeft size={18} /> Voltar para o site</a><form onSubmit={submit}><span className="login-icon"><LockKeyhole /></span><h2>Bem-vindo de volta</h2><p>Entre com os dados da sua equipe.</p><label>E-mail<input name="email" type="email" autoComplete="email" required placeholder="seu@email.com" /></label><label>Senha<div className="password-field"><input name="password" type={showPassword ? "text" : "password"} autoComplete="current-password" required placeholder="Sua senha" /><button type="button" aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"} onClick={() => setShowPassword(!showPassword)}>{showPassword ? <EyeOff /> : <Eye />}</button></div></label>{error && <div className="form-error">{error}</div>}<button className="button button-primary button-full" disabled={loading}>{loading ? <><span className="spinner" /> Entrando...</> : "Entrar no painel"}</button></form></div></div>;
}
